/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { useLanguage } from '@/providers/LanguageProvider';
import { AppListItem } from 'types/app-list';
import { FilterType, MeasuresData } from 'types/measures-api-data';

import { AppCardsList } from './app-cards-list';

interface DemoApplicationsProps {
  apps: AppListItem[];
  locale: string;
  measuresData: MeasuresData;
  activeFilter: FilterType;
  loading: boolean;
}

const DemoApplications = ({
  apps,
  locale,
  measuresData,
  activeFilter,
  loading,
}: DemoApplicationsProps) => {
  const { messages } = useLanguage();

  return (
    <div className="w-1/3 pb-4">
      <h3 className="text-h2 text-body-primary">
        {messages?.DashboardPage?.title?.demo_applications}
      </h3>
      <div className="mt-3 grid grid-cols-1 gap-3 [@media(min-width:1920px)]:grid-cols-2">
        <AppCardsList
          loading={loading}
          apps={apps}
          locale={locale}
          measuresData={measuresData}
          activeFilter={activeFilter}
        />
      </div>
    </div>
  );
};

export default DemoApplications;
